import React from 'react';
import PropTypes from 'prop-types';
import { FaCheck } from 'react-icons/fa';

import {
  ProgressContainer,
  ProgressDesktop,
  ProgressLine,
  ProgressLineFill,
  ProgressStep,
  ProgressStepCircle,
  ProgressStepLabel,
  ProgressMobile,
  ProgressMobileHeader,
  ProgressMobileMeta,
  ProgressMobileBar,
  ProgressMobileFill,
} from './ProgressBar.styles';

const steps = [
  {
    label: 'Your Account',
    shortLabel: 'Account',
  },
  {
    label: 'Company Info',
    shortLabel: 'Company',
  },
  {
    label: 'Address',
    shortLabel: 'Address',
  },
  {
    label: 'Review',
    shortLabel: 'Review',
  },
];

const CompanySignupProgressBar = ({ step, onStepClick }) => {
  const totalSteps = steps.length;
  const currentStep = steps[step] || steps[0];

  const progress = totalSteps > 1 ? (step / (totalSteps - 1)) * 100 : 0;

  const mobileProgress = ((step + 1) / totalSteps) * 100;

  const handleStepClick = (index) => {
    if (index > step || !onStepClick) return;

    onStepClick(index);
  };

  return (
    <ProgressContainer>
      <ProgressDesktop>
        <ProgressLine>
          <ProgressLineFill $progress={progress} />
        </ProgressLine>

        {steps.map((currentStepItem, index) => {
          const isActive = index === step;
          const isCompleted = index < step;
          const canClick = index <= step;

          return (
            <ProgressStep
              key={currentStepItem.label}
              $active={isActive}
              $completed={isCompleted}
              $clickable={canClick}
              onClick={() => handleStepClick(index)}
              aria-current={isActive ? 'step' : undefined}
            >
              <ProgressStepCircle $active={isActive} $completed={isCompleted}>
                {isCompleted ? <FaCheck /> : index + 1}
              </ProgressStepCircle>

              <ProgressStepLabel $active={isActive} $completed={isCompleted}>
                {currentStepItem.shortLabel}
              </ProgressStepLabel>
            </ProgressStep>
          );
        })}
      </ProgressDesktop>

      <ProgressMobile>
        <ProgressMobileHeader>
          <div>
            <ProgressMobileMeta>
              Step {step + 1} of {totalSteps}
            </ProgressMobileMeta>

            <strong>{currentStep.label}</strong>
          </div>

          <span>{Math.round(mobileProgress)}%</span>
        </ProgressMobileHeader>

        <ProgressMobileBar>
          <ProgressMobileFill $progress={mobileProgress} />
        </ProgressMobileBar>
      </ProgressMobile>
    </ProgressContainer>
  );
};

CompanySignupProgressBar.propTypes = {
  step: PropTypes.number,
  onStepClick: PropTypes.func,
};

CompanySignupProgressBar.defaultProps = {
  step: 0,
};

export default CompanySignupProgressBar;
